"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressIsNotMatchModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_router_dom_1 = require("react-router-dom");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var AddressIsNotMatchModalWidget = /** @class */ (function (_super) {
    __extends(AddressIsNotMatchModalWidget, _super);
    function AddressIsNotMatchModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.QUOTE_ADDRESS_CHANGE_PAGE = "propertyDetails";
        _this.goBack = _this.goBack.bind(_this);
        _this.quoteType = services_1.InteractionHelper.getQuoteType(_this.props.engine.getInteraction().product);
        return _this;
    }
    AddressIsNotMatchModalWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "notification-modal", isOpen: true, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { children: (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium", children: "Address does not match" }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "pt-0 fs-18", children: ["Sorry - your ", services_1.resourcesHelper.THEME, " account address doesn't match the one you entered, go to your account to update your address."] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalFooter, { className: "d-block", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/dashboard", className: "btn btn-primary btn-next plugin", onClick: this.setAddressChangeReferer, children: "Go to your account" }), (0, jsx_runtime_1.jsxs)("button", { className: "btn btn-back w-100 mt-0", onClick: this.goBack, children: ["Change ", this.quoteType, " quote address"] })] })] }) }));
    };
    AddressIsNotMatchModalWidget.prototype.setAddressChangeReferer = function () {
        window.sessionStorage.setItem(services_1.SessionStorageItemEnum.ADDRESS_CHANGE_REFERER, window.location.href);
    };
    AddressIsNotMatchModalWidget.prototype.goBack = function () {
        this.props.engine.navigate(this.QUOTE_ADDRESS_CHANGE_PAGE, false);
    };
    return AddressIsNotMatchModalWidget;
}(plugin_journey_1.WidgetBase));
exports.AddressIsNotMatchModalWidget = AddressIsNotMatchModalWidget;
//# sourceMappingURL=AddressIsNotMatchModalWidget.js.map